import script from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"

import "./ProportionalWithdrawalInput.vue?vue&type=style&index=0&id=7ec871af&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec871af"]])

export default __exports__